import { Avatar } from '@seek/avatar';
import { Box, Columns, Column, Stack } from 'braid-design-system';

import { Shimmer } from '../../Shimmer/Shimmer';

const ProfileCardShell = () => (
  <Box paddingY="large" style={{ minHeight: 250 }}>
    <Stack space="small">
      <Columns alignY="top" space="medium" collapseBelow="tablet">
        <Column width="content">
          <Columns alignY="center" space="none">
            <Column>
              <Avatar variant="icon" size="large" />
            </Column>
          </Columns>
        </Column>
        <Column>
          <Stack space="medium">
            <Columns space="small" alignY="top">
              <Column>
                <Box paddingTop="xsmall">
                  <Stack space="gutter">
                    <Stack space="small">
                      <Shimmer.Heading level="2" width="medium" />
                      <Shimmer.Text width="medium" />
                    </Stack>

                    <Stack space="small">
                      <Shimmer.Text width="large" />
                      <Shimmer.Text width="large" />
                    </Stack>

                    <Stack space="small">
                      <Shimmer.Text width="medium" />
                      <Shimmer.Text width="medium" />
                    </Stack>
                  </Stack>
                </Box>
              </Column>
            </Columns>

            <Columns space="medium" alignY="center" collapseBelow="tablet">
              <Column>
                <Shimmer.Text width="large" />
              </Column>
            </Columns>
          </Stack>
        </Column>
      </Columns>
    </Stack>
  </Box>
);

export { ProfileCardShell };
